<template>
  <!-- eslint-disable-next-line -->
  <div><slot :items-visible="itemsVisible" :items-in-modal="itemsInModal" :has-modal="hasModal" /></div>
</template>

<script>
export default {
  props: {
    gallery: {
      type: Array,
      required: true,
    },
    cropBy: {
      type: Number,
      default: 5,
    },
  },
  computed: {
    itemsVisible() {
      return this.gallery.slice(0, this.cropBy);
    },
    itemsInModal() {
      return this.gallery.slice(this.cropBy - 1);
    },
    hasModal() {
      return this.itemsInModal.length > 1;
    },
  },
};
</script>
